import { AxiosResponse } from "axios";
import { ISos, ISosPagination, ISosUpdateRequest } from "../interface/sos";
import { http } from "../utils/http";

export const filterSosApi = async (payload: {
  status?: string;
  page?: number;
  limit?: number;
}): Promise<AxiosResponse<ISosPagination>> => {
  return await http.get("/v1/admin/sos", payload)
};

export const updateSosApi = async (id: string, payload: ISosUpdateRequest): Promise<AxiosResponse<ISos>> => {
  return await http.patch(`/v1/admin/sos/${id}`, payload)
};
